import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
// 首页轮播
var banner = new Swiper('.swiper-container', {
    autoplay: {
        delay: 4000,
        disableOnInteraction: false,
    },
    speed:1000,
    loop:true,//必须
    effect : 'fade',
    fadeEffect: {
        crossFade: true,
    }
}); 